
import {Component, Vue, Prop} from 'vue-property-decorator';
import DataOverview from './components/DataOverview.vue';
import LearningProgress from './components/LearningProgress.vue';
import WorkData from './components/WorkData.vue';
import TeachingSituation from './components/TeachingSituation.vue';
@Component({
    components: {
        DataOverview,
        LearningProgress,
        WorkData,
        TeachingSituation
    }
})
export default class CustomerData extends Vue {
    schoolId = '';
    time = 'month';
    onSearch(schoolId: string) {
        // this.schoolId = schoolId;
        // (this.$refs['dataOverview'] as DataOverview).getCurrentTabData(schoolId);
        // (this.$refs['learningProgress'] as LearningProgress).getCourse(schoolId);
        // (this.$refs['teachingSituation'] as TeachingSituation).getData(schoolId);
        // (this.$refs['workData'] as WorkData).getOptionsData(schoolId);
        // (this.$refs['workData'] as WorkData).getWorkRateData(schoolId);
    }
    onchangeTime(val: any) {
        (this.$refs['learningProgress'] as LearningProgress).onChange(val);
        (this.$refs['teachingSituation'] as TeachingSituation).onChange(val);
        (this.$refs['workData'] as WorkData).onChange(val);
    }
    created() {}
}
